import * as yup from 'yup';

/**
 * Formik errors are strings, but we want to use a more specific type, ie 'required' instead of 'string'
 * These utils are used to from formik errors to our specific errors unions
 */

export const requiredError = 'required' as const;
export type RequiredError = typeof requiredError;

export const parseToRequiredError = (
  error?: string,
): RequiredError | undefined => (error ? requiredError : undefined);

/**
 * Yup schema utils
 */

export const text = yup.string().required(requiredError);
export const optionalText = yup.string().optional();
